import React from 'react'
const Icon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_12239_32025)">
      <path
        d="M12.5 23.52C6.1479 23.52 0.97998 18.3521 0.97998 12C0.97998 5.6479 6.1479 0.47998 12.5 0.47998C18.8521 0.47998 24.02 5.6479 24.02 12C24.02 18.3521 18.8521 23.52 12.5 23.52ZM12.5 1.91998C6.94182 1.91998 2.41998 6.44182 2.41998 12C2.41998 17.5581 6.94182 22.08 12.5 22.08C18.0581 22.08 22.58 17.5581 22.58 12C22.58 6.44182 18.0581 1.91998 12.5 1.91998ZM16.1 10.56C15.3058 10.56 14.66 9.91414 14.66 9.11998C14.66 8.32582 15.3058 7.67998 16.1 7.67998C16.8941 7.67998 17.54 8.32582 17.54 9.11998C17.54 9.91414 16.8941 10.56 16.1 10.56ZM8.89998 10.56C8.10582 10.56 7.45998 9.91414 7.45998 9.11998C7.45998 8.32582 8.10582 7.67998 8.89998 7.67998C9.69414 7.67998 10.34 8.32582 10.34 9.11998C10.34 9.91414 9.69414 10.56 8.89998 10.56ZM17.54 15.6C17.54 15.2023 17.2177 14.88 16.82 14.88H8.17998C7.7823 14.88 7.45998 15.2023 7.45998 15.6C7.45998 15.9977 7.7823 16.32 8.17998 16.32H16.82C17.2177 16.32 17.54 15.9977 17.54 15.6Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_12239_32025">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)
export default Icon
